var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#1E2A10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1881_1903)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 13.1094,
    fill: "#AAEF77"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5156 58.8852C33.5458 58.8852 40.0556 52.3754 40.0556 44.3452C40.0556 36.315 33.5458 29.8052 25.5156 29.8052C17.4854 29.8052 10.9756 36.315 10.9756 44.3452C10.9756 52.3754 17.4854 58.8852 25.5156 58.8852Z",
    fill: "#AAEF77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5156 58.8852C33.5458 58.8852 40.0556 52.3754 40.0556 44.3452C40.0556 36.315 33.5458 29.8052 25.5156 29.8052C17.4854 29.8052 10.9756 36.315 10.9756 44.3452C10.9756 52.3754 17.4854 58.8852 25.5156 58.8852Z",
    fill: "url(#paint0_linear_1881_1903)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5156 58.8852C33.5458 58.8852 40.0556 52.3754 40.0556 44.3452C40.0556 36.315 33.5458 29.8052 25.5156 29.8052C17.4854 29.8052 10.9756 36.315 10.9756 44.3452C10.9756 52.3754 17.4854 58.8852 25.5156 58.8852Z",
    fill: "url(#paint1_radial_1881_1903)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5449 26.2466C33.4012 26.2466 37.0995 27.7785 39.8262 30.5052C42.553 33.232 44.0849 36.9303 44.0849 40.7866",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5654 20.0864C42.0454 20.0864 50.5654 29.1564 50.5654 39.6364",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1046 63.8693L58.5847 58.2687C58.6894 58.1626 58.748 58.0195 58.748 57.8704C58.748 57.7213 58.6894 57.5782 58.5847 57.4721L57.9208 56.8203L56.2671 52.825C56.0039 52.1925 55.6183 51.6182 55.1325 51.1352L50.8112 46.9105C50.8112 46.9105 49.6042 45.8001 48.6144 46.5726C47.6246 47.3451 47.9022 48.1297 47.9022 48.1297C47.6716 47.8529 47.3552 47.661 47.0031 47.5845C46.6511 47.5079 46.2836 47.5511 45.9588 47.7072C45.6774 47.848 45.4457 48.0714 45.2947 48.3475C45.1437 48.6236 45.0806 48.9393 45.1139 49.2522C44.862 48.9616 44.5154 48.7695 44.1354 48.7099C43.7555 48.6502 43.3666 48.7269 43.0378 48.9263C42.7869 49.0994 42.5732 49.3211 42.4095 49.5782C42.2457 49.8352 42.1351 50.1225 42.0842 50.423L37.7388 46.3432C37.4179 45.9813 36.9687 45.7588 36.4864 45.7227C36.0041 45.6866 35.5268 45.84 35.1557 46.1501C34.8527 46.5287 34.7096 47.0107 34.7569 47.4932C34.8043 47.9758 35.0384 48.4207 35.4092 48.7332L41.8911 55.5167L40.1891 55.2391C39.6484 55.1566 39.0967 55.2846 38.6476 55.5967C38.1985 55.9089 37.8862 56.3814 37.775 56.9169C37.6802 57.4267 37.7751 57.9536 38.0419 58.3983C38.3088 58.843 38.729 59.1747 39.2235 59.3309L42.6032 60.3931C45.3291 62.0516 48.4128 63.0325 51.5958 63.2537H51.7648L52.2959 63.8211C52.3444 63.8795 52.4045 63.9273 52.4722 63.9616C52.54 63.9959 52.614 64.0159 52.6898 64.0204C52.7656 64.025 52.8415 64.0139 52.9129 63.9879C52.9842 63.9619 53.0495 63.9215 53.1046 63.8693Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1046 63.8693L58.5847 58.2687C58.6894 58.1626 58.748 58.0195 58.748 57.8704C58.748 57.7213 58.6894 57.5782 58.5847 57.4721L57.9208 56.8203L56.2671 52.825C56.0039 52.1925 55.6183 51.6182 55.1325 51.1352L50.8112 46.9105C50.8112 46.9105 49.6042 45.8001 48.6144 46.5726C47.6246 47.3451 47.9022 48.1297 47.9022 48.1297C47.6716 47.8529 47.3552 47.661 47.0031 47.5845C46.6511 47.5079 46.2836 47.5511 45.9588 47.7072C45.6774 47.848 45.4457 48.0714 45.2947 48.3475C45.1437 48.6236 45.0806 48.9393 45.1139 49.2522C44.862 48.9616 44.5154 48.7695 44.1354 48.7099C43.7555 48.6502 43.3666 48.7269 43.0378 48.9263C42.7869 49.0994 42.5732 49.3211 42.4095 49.5782C42.2457 49.8352 42.1351 50.1225 42.0842 50.423L37.7388 46.3432C37.4179 45.9813 36.9687 45.7588 36.4864 45.7227C36.0041 45.6866 35.5268 45.84 35.1557 46.1501C34.8527 46.5287 34.7096 47.0107 34.7569 47.4932C34.8043 47.9758 35.0384 48.4207 35.4092 48.7332L41.8911 55.5167L40.1891 55.2391C39.6484 55.1566 39.0967 55.2846 38.6476 55.5967C38.1985 55.9089 37.8862 56.3814 37.775 56.9169C37.6802 57.4267 37.7751 57.9536 38.0419 58.3983C38.3088 58.843 38.729 59.1747 39.2235 59.3309L42.6032 60.3931C45.3291 62.0516 48.4128 63.0325 51.5958 63.2537H51.7648L52.2959 63.8211C52.3444 63.8795 52.4045 63.9273 52.4722 63.9616C52.54 63.9959 52.614 64.0159 52.6898 64.0204C52.7656 64.025 52.8415 64.0139 52.9129 63.9879C52.9842 63.9619 53.0495 63.9215 53.1046 63.8693Z",
    fill: "url(#paint2_linear_1881_1903)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3056 43.5158L23.9756 38.5158C23.8275 38.4387 23.6624 38.3999 23.4954 38.403C23.3285 38.4061 23.1649 38.451 23.0198 38.5335C22.8746 38.616 22.7524 38.7336 22.6643 38.8755C22.5763 39.0174 22.5252 39.179 22.5156 39.3458V49.3458C22.5252 49.5125 22.5763 49.6742 22.6643 49.8161C22.7524 49.9579 22.8746 50.0755 23.0198 50.158C23.1649 50.2406 23.3285 50.2854 23.4954 50.2885C23.6624 50.2916 23.8275 50.2529 23.9756 50.1758L32.3056 45.1758C32.4417 45.0843 32.5533 44.9607 32.6304 44.816C32.7075 44.6713 32.7478 44.5098 32.7478 44.3458C32.7478 44.1817 32.7075 44.0203 32.6304 43.8755C32.5533 43.7308 32.4417 43.6072 32.3056 43.5158Z",
    fill: "#212E12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3056 43.5158L23.9756 38.5158C23.8275 38.4387 23.6624 38.3999 23.4954 38.403C23.3285 38.4061 23.1649 38.451 23.0198 38.5335C22.8746 38.616 22.7524 38.7336 22.6643 38.8755C22.5763 39.0174 22.5252 39.179 22.5156 39.3458V49.3458C22.5252 49.5125 22.5763 49.6742 22.6643 49.8161C22.7524 49.9579 22.8746 50.0755 23.0198 50.158C23.1649 50.2406 23.3285 50.2854 23.4954 50.2885C23.6624 50.2916 23.8275 50.2529 23.9756 50.1758L32.3056 45.1758C32.4417 45.0843 32.5533 44.9607 32.6304 44.816C32.7075 44.6713 32.7478 44.5098 32.7478 44.3458C32.7478 44.1817 32.7075 44.0203 32.6304 43.8755C32.5533 43.7308 32.4417 43.6072 32.3056 43.5158Z",
    fill: "url(#paint3_linear_1881_1903)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1881_1903",
    x: 0.890625,
    y: 0.890625,
    width: 74.2188,
    height: 74.2188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1881_1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1881_1903",
    x1: -0.734929,
    y1: -12.2827,
    x2: 18.2846,
    y2: 67.9768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764629,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1881_1903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5716 84.7852) rotate(-106.066) scale(62.7606 72.9456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.606936,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1881_1903",
    x1: 30.328,
    y1: 49.3591,
    x2: 51.5073,
    y2: 73.1743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764629,
    stopColor: "#F8FCF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1881_1903",
    x1: 25.041,
    y1: 43.3342,
    x2: 29.2568,
    y2: 49.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80D11B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVod);
export default __webpack_public_path__ + "static/media/icon-vod.b7f4805f419dcd3da6bfd86e98027750.svg";
export { ForwardRef as ReactComponent };